<template>
  <ok-modal
    :value="value"
    size="sm"
    :no-close-on-backdrop="loading"
    :title="$t('subscription.get-quote')"
    @change="loading ? null : $emit('input', $event)"
  >
    <error-alert :error="error" />

    <div class="text-center text-secondary">
      <div class="text-large font-weight-bold mb-2">
        <div class="mb-1">
          {{ $t('subscription.contact-us-directly') }}
        </div>

        <div dir="ltr">
          <a :href="`tel:${CONTACT_PHONE}`">
            {{ CONTACT_PHONE }}
          </a>
        </div>
      </div>

      <div class="text-large description-text mb-2">
        {{ $t('general.or') }}
      </div>

      <b-button
        variant="primary"
        :disabled="loading"
        @click="submit"
      >
        <b-spinner
          v-if="loading"
          small
        />
        <span v-else>
          {{ $t('subscription.request-for-call-back') }}
        </span>
      </b-button>
    </div>
  </ok-modal>
</template>

<script>
import { BSpinner, BButton } from 'bootstrap-vue'
import OkModal from '@/@okmenu/components/modals/OkModal'
import SubscriptionAPIs from '@/API/subscription/subscription-api'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import { CONTACT_PHONE } from '@/constants/config'

export default {
  name: 'QuoteModal',
  components: {
    ErrorAlert, OkModal, BSpinner, BButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      CONTACT_PHONE,
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.error = null
      SubscriptionAPIs.customRequest()
        .then(({ message }) => {
          this.$emit('input', false)
          this.$notifySuccess(message)
        })
        .catch(error => { this.error = error })
        .finally(() => { this.loading = false })
    },
  },
}
</script>
